export default {
  language: 'Language',
  loadParser: 'Load Parser File',
  uploadParser: 'Upload parser file',
  loadSample: 'Load sample data',
  download: 'Download parser file',
  imprint: 'Imprint',
  help: 'Help',
  parser_repository: 'Parser Repository',
  welcome: {
  message: 'Welcome! New here? Start',
  here: 'here'
  },
  repository: {
    helpText: 'This section allows you to load parser configurations from the community repository.',
    contributeText: 'Want to share your own parser? Visit the repository for information on how to contribute your configurations to help the community.'
  }
}